import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import withRedirect from "../../helpers/hoc/withRedirect";
import {
  deleteOneProperty,
  fetchOneProperty,
  unlinkPropertyOwner,
} from "../../helpers/api/condominium";
import PageHeader from "../common/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonIcon from "../common/ButtonIcon";
import { faInfoCircle, faMinus, faLink, faUnlink } from "@fortawesome/free-solid-svg-icons";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "./../UI/toast/Toast";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { useHistory } from "react-router-dom";
import ProfileBanner from "./profile/ProfileBanner";
import SupportLink from "../root/support/components/SupportLink";
import Loader from "../common/Loader";
import ProfilePassword from "./profile/ProfilePassword";
import ProfileBasic from "./profile/ProfileBasic";
import ProfileContact from "./profile/ProfileContact";
import ProfileAddress from "./profile/ProfileAddress";
import { useForm } from "react-hook-form";
import { updatedUserProfile } from "../../actions/authActions";
import { fetchWithAuthorization } from "../../helpers/api/fetch";
import ProfileBasicAdmin from "./profile/ProfileBasicAdmin";
import ProfileAddressAdmin from "./profile/ProfileAddressAdmin";
import LinkOwnerModal from "./LinkOwnerModal";

const PropertyDetails = ({ setRedirect, setRedirectUrl }) => {
  const { property } = useParams();
  const history = useHistory();
  const { condominium } = useSelector((state) => state.condominium);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [linkOwnerOpen, setLinkOwnerOpen] = useState(false);
  const [unlinkConfirmOpen, setUnlinkConfirmOpen] = useState(false);
  const [unlinking, setUnlinking] = useState(false);
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();
  const [wasBeEdited, setWasBeEdited] = useState(false);

  const reloadProperty = () => {
    if (!property) return;
    fetchOneProperty({ propertyId: property })
      .then((val) => setData(val.data))
      .catch((error) => {
        setError(error);
        handleErrorMessage(error);
      })
      .finally(() => setIsLoading(false));
  };

  const handleUnlink = async () => {
    setUnlinking(true);
    try {
      await unlinkPropertyOwner(data.id);
      Toast.fire({
        type: "success",
        title: "Se deshizo el vínculo: la propiedad volvió a su cuenta anterior.",
      });
      setUnlinkConfirmOpen(false);
      reloadProperty();
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      setUnlinking(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (property) {
      (async () => {
        fetchOneProperty({ propertyId: property })
          .then((val) => {
            isMounted && setData(val.data);
          })
          .catch((error) => {
            isMounted && setError(error);
            handleErrorMessage(error);
          })
          .finally(() => {
            isMounted && setIsLoading(false);
          });
      })();
    }
    return () => {
      isMounted = false;
    };
  }, [property]);

  const handleDelete = () => {
    collapseOneOpen(false);
    deleteProp();
  };

  const handleModal = () => {
    <Modal isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Eliminar propietario</ModalHeader>
      <ModalBody>
        <p className="mb-0 font-weight-bold fs--1">
          ¿Está seguro de eliminar el propietario {data.user?.data.firstname}{" "}
          {data.user?.data.lastname}?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => collapseOneOpen(!collapseOne)}>Cancelar</Button>
        <Button
          data-testid="delete-button"
          color="danger"
          onClick={handleDelete}
        >
          Eliminar
        </Button>
      </ModalFooter>
    </Modal>;
  };

  /*   const loadData = () => {
    setUserData({});
    setLoading(true);
    checkUserToken(token)
      .then(({ username, data }) => {
        setUsername(username);
        setUserData(data);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  }; */

  const updateData = async (e) => {
    try {
      setLoading(true);
      const res = await fetchWithAuthorization(
        `/profile/update/${data?.user?.id}`,
        e,
        "PUT"
      );
      if (res) {
        dispatch(updatedUserProfile(e));
        /*  loadData(); */
        Toast.fire({
          type: "success",
          title: "Datos actualizados con exito.",
        });
      }
    } catch (e) {
      setError(e);
      handleErrorMessage(e);
    } finally {
      setWasBeEdited(false);
      setLoading(false);
    }
  };

  const deleteProp = async () => {
    try {
      const { code } = await deleteOneProperty(data.id);
      if (code === SUCCESS_RESPONSE.OK) {
        Toast.fire({
          type: "success",
          title: "Se ha eliminado el propietario satisfactoriamente.",
        });
        setRedirectUrl("/dashboard/properties/");
        setRedirect(true);
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const getDate = (date) => {
    var d = new Date(date);
    const meses = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ];
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return `${
      meses[d.getMonth()]
    } ${d.getDate()}, ${d.getFullYear()} ${strTime}`;
  };

  return (
    <>
      <PageHeader
        title={`Información del propietario del condominio ${condominium}`}
        titleTag="h2"
        description="Ve la información del propietario."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <PreloadState cond={!!data.user} loading={isLoading}>
        <Or value={true}>
          <ProfileBanner
            edit={false}
            emphasis={`(${data.user?.username})`}
            firstname={data.user?.data.firstname}
            lastname={data.user?.data.lastname}
            image={data.user?.data.image}
            direction={data.user?.data.direction}
          >
            <Row className="justify-content-between align-items-center">
              <Col xs={6} className="d-flex align-items-center">
                <div className="media">
                  <FontAwesomeIcon icon="user" color="#00d27a" />
                </div>
                <div className="media-body ml-2">
                  <p className="mb-0">Propietario creado el</p>
                  <p className="fs--1 mb-0 text-600">
                    {getDate(data.user?.created_at)}
                  </p>
                </div>
              </Col>
            </Row>
          </ProfileBanner>
          <Card>
            <CardHeader className="bg-light">
              <Container>
                <Row className="align-items-center">
                  <Col>
                    <h5 className="mb-0">Detalles</h5>
                  </Col>
                  <Col xs="auto">
                    <Button
                      color="falcon-default"
                      size="sm"
                      onClick={() => setLinkOwnerOpen(true)}
                    >
                      <FontAwesomeIcon icon={faLink} className="mr-1" />
                      Vincular a propietario existente
                    </Button>
                    {data.hasActiveLink && (
                      <Button
                        color="falcon-default"
                        size="sm"
                        className="ml-2"
                        onClick={() => setUnlinkConfirmOpen(true)}
                      >
                        <FontAwesomeIcon icon={faUnlink} className="mr-1" />
                        Desvincular
                      </Button>
                    )}
                  </Col>
                </Row>
              </Container>
            </CardHeader>
            <CardBody className="border-top bg-light">
              <Row>
                <div className="col-xxl-5 col-lg">
                  <h6 className="font-weight-semi-bold ls mb-3 text-uppercase">
                    Información de la cuenta
                  </h6>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">ID</p>
                    </div>
                    <div className="col">{data.id}</div>
                  </div>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">Creado</p>
                    </div>
                    <div className="col">{getDate(data.user?.created_at)}</div>
                  </div>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">Usuario</p>
                    </div>
                    <div className="col">
                      <p className="mb-1 text-primary">{data.user?.username}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">Es compañía</p>
                    </div>
                    <div className="col">
                      <p className="font-italic text-400 mb-1">
                        {data.user?.isCompany === 1 ? "SI" : "NO"}
                      </p>
                    </div>
                  </div>
                  {data.property && (
                    <div className="row">
                      <div className="col-5 col-sm-4">
                        <p className="font-weight-semi-bold mb-1">Inmueble</p>
                      </div>
                      <div className="col">
                        <p className=" mb-1">{data.property}</p>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-0">Condominio</p>
                    </div>
                    <div className="col">
                      <p>{data.condominium?.name}</p>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-5 mt-4 mt-lg-0 offset-xxl-1 col-lg">
                  <h6 className="font-weight-semi-bold ls mb-3 text-uppercase">
                    Información personal
                  </h6>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">DNI</p>
                    </div>
                    <div className="col">
                      {!data.user?.data.dni ? (
                        <p className="font-italic text-400 mb-1">NO AGREGADO</p>
                      ) : (
                        <p className="mb-1">{data.user?.data.dni}</p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">Nombre</p>
                    </div>
                    <div className="col">
                      <p className="mb-1">{data.user?.data.firstname}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">Apellido</p>
                    </div>
                    <div className="col">
                      <p className="mb-1">{data.user?.data.lastname}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 col-sm-4">
                      <p className="font-weight-semi-bold mb-1">
                        No de teléfono
                      </p>
                    </div>
                    <div className="col">
                      {!data.user?.data.phone ? (
                        <p className="font-italic text-400 mb-1">NO AGREGADO</p>
                      ) : (
                        <a href={`tel:${data.user?.data.phone}`}>
                          {data.user?.data.phone}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Or>
        <Or value={false} cond={!!error}>
          <Message
            className="p-3"
            color={"info"}
            icon={faInfoCircle}
            value={true}
          >
            <>No hay informacion para mostrar.</>
          </Message>
          <Message
            className="p-3"
            color={"danger"}
            icon={faInfoCircle}
            value={true}
          >
            <>
              Esta página no está disponible
              <Button
                data-testid="Button"
                color="link"
                size="sm"
                className="ml-1 pl-0"
                onClick={() => history.goBack()}
              >
                Volver
              </Button>
            </>
          </Message>
        </Or>
      </PreloadState>
      {handleModal()}
      <LinkOwnerModal
        isOpen={linkOwnerOpen}
        toggle={() => setLinkOwnerOpen(false)}
        property={data}
        onLinked={reloadProperty}
      />
      <Modal isOpen={unlinkConfirmOpen} toggle={() => setUnlinkConfirmOpen(false)}>
        <ModalHeader toggle={() => setUnlinkConfirmOpen(false)}>
          Desvincular propiedad
        </ModalHeader>
        <ModalBody>
          <p className="mb-0 fs--1">
            ¿Estás seguro de deshacer el vínculo de{" "}
            <strong>{data.property || "esta propiedad"}</strong>? Va a volver
            a pertenecer a la cuenta que tenía antes de vincularse.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => setUnlinkConfirmOpen(false)}
            disabled={unlinking}
          >
            Cancelar
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={handleUnlink}
            disabled={unlinking}
          >
            {unlinking ? "Desvinculando..." : "Sí, desvincular"}
          </Button>
        </ModalFooter>
      </Modal>
      {/*
      <Card className="mb-3 bg-light">
        <CardBody>
          <PreloadState cond={data ? true : false} loading={isLoading}>
            <Or value={true}>
              <Form onSubmit={handleSubmit(updateData)}>
                <ProfilePassword data={data} username={data.user?.username} />
                <ProfileBasicAdmin
                  wasBeEdited={() => setWasBeEdited(true)}
                  edit={!isLoading}
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  dni={data.user?.data.dni}
                  firstname={data.user?.data.firstname}
                  lastname={data.user?.data.lastname}
                />
                <ProfileContact
                  wasBeEdited={() => setWasBeEdited(true)}
                  edit={!isLoading}
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  phone={data.user?.data?.phone}
                   email={data.user?.data?.email}
                />
                <ProfileAddressAdmin
                  wasBeEdited={() => setWasBeEdited(true)}
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  edit={!isLoading}
                  address={data.user?.data.address}
                />
                <Row>
                  <Col className="d-flex justify-content-end align-items-center mt-3">
                    <ButtonIcon
                      data-testid="submit-button"
                      color="primary"
                      className="px-5"
                      type="submit"
                      icon="save"
                      disabled={isLoading || !wasBeEdited}
                      transform="down-1 shrink-4"
                    >
                      Actualizar
                    </ButtonIcon>
                  </Col>
                </Row>
              </Form>
            </Or>
            <Or value={false}>
              <></>
            </Or>
          </PreloadState>
        </CardBody>
      </Card> */}
    </>
  );
};

export default withRedirect(PropertyDetails);
